import angular from 'angular';
import moment from 'moment-timezone';
import { find, map } from 'lodash';

module.exports = angular.module('common.directives.service_account_indicators', [])
.directive('ocServiceAccountIndicators', function() {
  var GLYPS = {
    electricity: ['glyphicon', 'glyphicon-flash'],
    water: ['glyphicon', 'glyphicon-tint'],
    gas: ['glyphicon', 'glyphicon-fire'],
    insurance: ['glyphicon', 'glyphicon-folder-close'],
  };

  return {
    restrict: 'C',
    scope: {
      accountTypes: '=',
      accounts: '=',
    },
    templateUrl: '/templates/common/directives/service_account_indicators.html',
    controller: function($scope, titlecaseFilter) {
      $scope.$watchCollection('accounts', updateIndicators);
      $scope.$watchCollection('accountTypes', updateIndicators);

      function updateIndicators() {
        var accounts = $scope.accounts,
            types = $scope.accountTypes;

        if (!accounts || !types) return;

        $scope.indicators = map(types, function(type) {
          var classes = [].concat(GLYPS[type] || []);
          var account = find($scope.accounts, { kind: type });
          if (!account || account.deactivated || !account.activation_date) {
            classes.push('inactive');
          } else if (account.currently_active) {
            classes.push('currently-active');
          } else {
            classes.push('scheduled');
          }

          return {
            type: type,
            account: account,
            classes: classes,
            popover: popoverText(account)
          };
        });
      }

      function popoverText(account) {
        if (!account) return 'Not scheduled';
        let kind = titlecaseFilter(account.kind);
        var str = '';
        if (account.deactivated) {
          str = `${kind} deactivated on ${moment(account.deactivation_date).format('MMM D')}`;
        } else if (account.currently_active) {
          str = `${kind} is on`;
        } else if (account.activation_date && !account.currently_active) {
          str = `${kind} scheduled for ${moment(account.activation_date).format('MMM D')}`;
        } else {
          str = `${kind} not scheduled`;
        }
        return str;
      }
    }
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/service_account_indicators.js
 **/